/**
 * Peppol (BCSolutions) screens: company settings and registration, invoice
 * sending. Merged into each locale like fmShared (see src/i18n.js).
 */
export default {
  fr_BE: {
    attributes: {
      business_number: "numéro d'entreprise",
      siren: 'SIREN'
    },
    enums: {
      peppol_integrator: { bcsolutions: 'BCSolutions' },
      peppol_send_mode: {
        manual: 'manuel, depuis la facture',
        when_established: 'automatique quand la facture est établie'
      },
      peppol_invoice_status: {
        Pending: 'en cours',
        Ok: 'reçue',
        Error: 'rejetée'
      }
    },
    global: {
      peppol: {
        integrator: 'intégrateur Peppol',
        no_integrator: 'aucun',
        send_mode: "mode d'envoi",
        responsible: 'responsable du compte BCSolutions',
        bcsolutions_unavailable:
          "BCSolutions n'est pas configuré sur cet environnement : il ne peut pas être choisi.",
        onboarding_status: 'inscription BCSolutions',
        onboarding_email:
          "L'inscription se termine en quelques jours : la société reçoit un mail de BCSolutions et a 3 jours pour fournir la pièce d'identité du représentant et un Kbis de moins de 3 mois. L'activation prend ensuite environ un jour.",
        status_unavailable:
          "Le statut de l'inscription n'a pas pu être lu. Réessayez dans un instant.",
        status: {
          registering: 'inscription en cours…',
          form: 'formulaire à compléter',
          form_link_hint:
            'Le formulaire BCSolutions est prêt : ouvrez-le pour terminer.',
          form_email_hint:
            'Un mail de BCSolutions a été envoyé à la société pour terminer.',
          review: 'en vérification chez BCSolutions',
          active: 'active : la société peut envoyer sur Peppol',
          expired: 'délai de 3 jours dépassé',
          failed: 'échec',
          failed_hint: "L'inscription a échoué : contactez le support."
        },
        sent_at: 'envoyée sur Peppol le {date}',
        locked:
          'Facture envoyée sur Peppol : elle ne peut plus être modifiée. Établissez une note de crédit pour la corriger.'
      }
    },
    button: {
      peppol: {
        register: "s'inscrire chez BCSolutions",
        refresh_status: 'actualiser',
        restart_onboarding: "relancer l'inscription",
        open_onboarding: 'ouvrir le formulaire',
        send: 'envoyer sur Peppol',
        resend: 'renvoyer sur Peppol'
      }
    },
    toasts: {
      peppol: { sent: 'facture envoyée sur Peppol' }
    }
  },
  nl_BE: {
    attributes: {
      business_number: 'ondernemingsnummer',
      siren: 'SIREN'
    },
    enums: {
      peppol_integrator: { bcsolutions: 'BCSolutions' },
      peppol_send_mode: {
        manual: 'manueel, vanuit de factuur',
        when_established: 'automatisch wanneer de factuur is opgemaakt'
      },
      peppol_invoice_status: {
        Pending: 'bezig',
        Ok: 'ontvangen',
        Error: 'geweigerd'
      }
    },
    global: {
      peppol: {
        integrator: 'Peppol-integrator',
        no_integrator: 'geen',
        send_mode: 'verzendwijze',
        responsible: 'verantwoordelijke van het BCSolutions-account',
        bcsolutions_unavailable:
          'BCSolutions is niet geconfigureerd op deze omgeving: het kan niet worden gekozen.',
        onboarding_status: 'BCSolutions-inschrijving',
        onboarding_email:
          'De inschrijving duurt enkele dagen: de onderneming ontvangt een e-mail van BCSolutions en heeft 3 dagen om de identiteitskaart van de vertegenwoordiger en een Kbis van minder dan 3 maanden te bezorgen. De activering duurt daarna ongeveer een dag.',
        status_unavailable:
          'De status van de inschrijving kon niet worden gelezen. Probeer het zo meteen opnieuw.',
        status: {
          registering: 'inschrijving bezig…',
          form: 'formulier in te vullen',
          form_link_hint:
            'Het BCSolutions-formulier is klaar: open het om af te ronden.',
          form_email_hint:
            'BCSolutions heeft de onderneming een e-mail gestuurd om af te ronden.',
          review: 'in controle bij BCSolutions',
          active: 'actief: de onderneming kan via Peppol verzenden',
          expired: 'termijn van 3 dagen verstreken',
          failed: 'mislukt',
          failed_hint:
            'De inschrijving is mislukt: neem contact op met support.'
        },
        sent_at: 'via Peppol verzonden op {date}',
        locked:
          'Factuur via Peppol verzonden: ze kan niet meer worden gewijzigd. Maak een creditnota op om ze te corrigeren.'
      }
    },
    button: {
      peppol: {
        register: 'inschrijven bij BCSolutions',
        refresh_status: 'vernieuwen',
        restart_onboarding: 'inschrijving opnieuw starten',
        open_onboarding: 'formulier openen',
        send: 'via Peppol verzenden',
        resend: 'opnieuw via Peppol verzenden'
      }
    },
    toasts: {
      peppol: { sent: 'factuur via Peppol verzonden' }
    }
  }
}
